<h2 mat-dialog-title>{{data.titulo}}</h2>
<div mat-dialog-content>
  <h3>{{data.pergunta}}</h3>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Fechar</button>
  <button mat-button [mat-dialog-close]="'OK'">Confirmar</button>
</div>
